export const copyToClipboard = (str: string): void => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    if (document.body) document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    if (document.body) document.body.removeChild(el);
};
